import { Navigate, useRoutes } from "react-router-dom";
import Login from "../../Pages/Login";
import Layout from "../../Components/Layout/layout";
import React from "react";
import Programs from "../../Pages/Programs";
import ProgramCategory from "../../Pages/ProgramCategory";
import Status from "../../Pages/Status";
import Permission from "../../Pages/Permission";
import Role from "../../Pages/Role";
import RolePermission from "../../Pages/RolePermission";
import EmailVendor from "../../Pages/EmailVendor.js";
import Skill from "../../Pages/Skill";
import Standard from "../../Pages/Standard";
import Country from "../../Pages/Country";
import State from "../../Pages/State";
import City from "../../Pages/City";
import College from "../../Pages/College";
import Course from "../../Pages/Course";
import School from "../../Pages/School";
import Board from "../../Pages/Board";
import Book from "../../Pages/Book";
import Activity from "../../Pages/Activity";
import Company from "../../Pages/Company";
import User from "../../Pages/Users";
import Todo from "../../Pages/Todo";
import Career from "../../Pages/Career";
import Intake from "../../Pages/Intake";
import CalendarSystem from "../../Pages/CalendarSystem";
import CollegeRanking from "../../Pages/CollegeRanking";
import CollegeScholarship from "../../Pages/CollegeScholarship";
import CollegeAndCourse from "../../Pages/CollegeAndCourse";
import Exam from "../../Pages/Exam/index.js";
import CollegeExam from "../../Pages/CollegeExam/index.js";
import Students from "../../Pages/Students/index.js";
import SkillMedia from "../../Pages/Skill/SkillMedia/index.js";
import SkillBenefits from "../../Pages/Skill/SkillBenefits/index.js";
import SkillQuizes from "../../Pages/Skill/SkillQuizes/index.js";
import Quizzes from "../../Pages/Quizzes/index.js";
import QuizQuestions from "../../Pages/Quizzes/QuizQuestions.js";
import Questions from "../../Pages/Questions/index.js";
import Products from "../../Pages/Products/index.js";
import ProductBenefits from "../../Pages/Products/Benefits.js";
import ProductInstructions from "../../Pages/Products/Instructions.js";
import ProductGallery from "../../Pages/Products/Gallery.js";
import CollegeCourseExam from "../../Pages/CollegeAndCourse/Exam.js";
import UserProducts from "../../Pages/Users/Products.js";
import Level from "../../Pages/Level/index.js";
import ScholarshipsMapping from "../../Pages/ScholarshipsMapping/index.js";
import Scholarship from "../../Pages/Scholarship/index.js";
import Currency from "../../Pages/Currency/index.js";
import ExamMapping from "../../Pages/ExamMapping/index.js";
import CareerDeepDive from "../../Pages/CareerDeepDive/index.js";
import CareerList from "../../Pages/CareerDeepDive/list.js";

export default function Router({ isLoggedIn }) {
  return useRoutes([
    //public routes
    { path: "/", element: isLoggedIn() ? <Navigate to="/programs" replace /> : <Login /> },
    { path: "/login", element: isLoggedIn() ? <Navigate to="/programs" replace /> : <Login /> },

    { path: "*", element: <Navigate to="/login" replace /> },
    { path: "", element: <Navigate to="/login" replace /> },

    //private routes
    isLoggedIn() && {
      path: "/",
      element: <Layout />,
      children: [
        { path: "/programs", element: <Programs /> },
        { path: "/program-category", element: <ProgramCategory /> },
        { path: "/status", element: <Status /> },
        { path: "/permission", element: <Permission /> },
        { path: "/role", element: <Role /> },
        { path: "/role-permission", element: <RolePermission /> },
        { path: "/email-vendor", element: <EmailVendor /> },
        { path: "/skill", element: <Skill /> },
        { path: "/standard", element: <Standard /> },
        { path: "/country", element: <Country /> },
        { path: "/state", element: <State /> },
        { path: "/city", element: <City /> },
        { path: "/college", element: <College /> },
        { path: "/course", element: <Course /> },
        { path: "/school", element: <School /> },
        { path: "/board", element: <Board /> },
        { path: "/book", element: <Book /> },
        { path: "/activity", element: <Activity /> },
        { path: "/company", element: <Company /> },
        { path: "/user", element: <User /> },
        { path: "/todo", element: <Todo /> },
        { path: "/career", element: <Career /> },
        { path: "/intake", element: <Intake /> },
        { path: "/calendar-system", element: <CalendarSystem /> },
        { path: "/college-ranking", element: <CollegeRanking /> },
        { path: "/college-scholarship", element: <CollegeScholarship /> },
        { path: "/college-course", element: <CollegeAndCourse /> },
        { path: "/exam", element: <Exam /> },
        { path: "/college-exam", element: <CollegeExam /> },
        { path: "/students", element: <Students /> },
        { path: "/students", element: <Students /> },
        { path: "/skill/benefits", element: <SkillBenefits /> },
        { path: "/skill/media", element: <SkillMedia /> },
        { path: "/skill/quizes", element: <SkillQuizes /> },
        { path: "/quizzes", element: <Quizzes /> },
        { path: "/quiz/questions", element: <QuizQuestions /> },
        { path: "/questions", element: <Questions /> },
        { path: "/products", element: <Products /> },
        { path: "/product/benefits", element: <ProductBenefits /> },
        { path: "/product/instructions", element: <ProductInstructions /> },
        { path: "/product/gallery", element: <ProductGallery /> },
        { path: "/college-course/exam", element: <CollegeCourseExam /> },
        { path: "/product/user-products", element: <UserProducts /> },
        { path: "/level", element: <Level /> },
        { path: "/scholarships-mapping", element: <ScholarshipsMapping /> },
        { path: "/scholarships", element: <Scholarship /> },
        { path: "/currency", element: <Currency /> },
        { path: "/exam-mapping", element: <ExamMapping /> },
        { path: "/career-deep-dive/:id", element: <CareerDeepDive /> },
        { path: "/career-deep-dive", element: <CareerDeepDive /> },
        { path: "/career-list", element: <CareerList /> },
      ],
    },
  ]);
}
